package br.com.vvrefeicoes.portal

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport(configure = { isA11YEnabled = true }) {
        App()
    }
}
